var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import config from "../config/config.json.js";
import fetch from "cross-fetch";
import country from "../../packages/@okta/i18n/src/json/country.json.js";
import login from "../../packages/@okta/i18n/src/json/login.json.js";
import _ from "../../packages/@okta/courage-dist/esm/lib/underscore/underscore-min.js";
import fn from "./BrowserFeatures.js";
import Logger from "./Logger.js";
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
const STORAGE_KEY = "osw.languages";
function parseOverrides(i18n) {
  if (!i18n) {
    return {};
  }
  const i18nWithLowerCaseKeys = {};
  _.each(_.keys(i18n), function(key) {
    i18nWithLowerCaseKeys[key.toLowerCase()] = i18n[key];
  });
  return _.mapObject(i18nWithLowerCaseKeys, function(props) {
    const mapped = {
      login: {},
      country: {}
    };
    if (!_.isObject(props)) {
      throw new Error('Invalid format for "i18n"');
    }
    _.each(props, function(val, key) {
      const split = key.split(/^country\./);
      if (split.length > 1) {
        mapped.country[split[1]] = val;
      } else {
        mapped.login[split[0]] = val;
      }
    });
    return mapped;
  });
}
function getCachedLanguages() {
  let storage = JSON.parse(localStorage.getItem(STORAGE_KEY));
  if (!storage || storage.version !== config.version) {
    storage = {
      version: config.version
    };
  }
  return storage;
}
function addLanguageToCache(language, loginJson, countryJson) {
  const current = getCachedLanguages();
  current[language] = {
    login: loginJson,
    country: countryJson
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
}
function fetchJson(bundle, language, assets) {
  const languageCode = language.replace("-", "_");
  const path = assets.rewrite(encodeURI(`/labels/json/${bundle}_${languageCode}.json`));
  const headers = {
    Accept: "application/json",
    "Content-Type": "text/plain"
  };
  const mode = "no-cors";
  return fetch(assets.baseUrl + path, {
    method: "GET",
    headers,
    mode
  }).then((res) => res.text()).then((txt) => JSON.parse(txt));
}
function getBundles(language, assets, supportedLanguages) {
  return __async(this, null, function* () {
    if (language === config.defaultLanguage || !_.contains(supportedLanguages, language)) {
      return {};
    }
    const localStorageIsSupported = !fn.localStorageIsNotSupported();
    if (localStorageIsSupported) {
      const cached = getCachedLanguages();
      if (cached[language]) {
        return cached[language];
      }
    }
    try {
      const [loginJson, countryJson] = yield Promise.all([fetchJson("login", language, assets), fetchJson("country", language, assets)]);
      if (localStorageIsSupported) {
        addLanguageToCache(language, loginJson, countryJson);
      }
      return {
        login: loginJson,
        country: countryJson
      };
    } catch (_e) {
      Logger.warn("Unable to load language: " + language);
      return {};
    }
  });
}
var Bundles = {
  login,
  country,
  // Courage components within the sign in widget point to courage bundle to look
  // up i18nkeys. Since we dont have courage.properties inside the sign in widget
  // we are pointing courage bundle to login.
  courage: login,
  currentLanguage: null,
  isLoaded: function(language) {
    return this.currentLanguage === language;
  },
  remove: function() {
    this.currentLanguage = null;
  },
  loadLanguage: function(language, overrides, assets, supportedLanguages) {
    return __async(this, null, function* () {
      const parsedOverrides = parseOverrides(overrides);
      const lowerCaseLanguage = language.toLowerCase();
      const bundles = yield getBundles(language, assets, supportedLanguages);
      this.login = _.extend({}, login, bundles.login);
      this.country = _.extend({}, country, bundles.country);
      this.courage = _.extend({}, login, bundles.login);
      if (parsedOverrides[lowerCaseLanguage]) {
        _.extend(this.login, parsedOverrides[lowerCaseLanguage]["login"]);
        _.extend(this.country, parsedOverrides[lowerCaseLanguage]["country"]);
        _.extend(this.courage, parsedOverrides[lowerCaseLanguage]["login"]);
      }
      this.currentLanguage = language;
    });
  }
};
export { Bundles as default };
